import { motion } from "framer-motion";

const painPoints = [
  "Unreliable rides and no-shows",
  "Difficult scheduling across shifts and locations",
  "High or unpredictable transportation costs",
  "Employee commuting challenges",
  "Managing multiple transport providers",
];

const scrollToForm = () => {
  document.getElementById("assessment-form")?.scrollIntoView({ behavior: "smooth" });
};

const Problem = () => (
  <section data-testid="problem-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
      >
        <p className="text-xs font-medium tracking-[0.2em] uppercase text-orange-600 mb-4">
          Start with the problem
        </p>
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-stone-900">
          What&rsquo;s your current transport problem?
        </h2>
        <p className="mt-6 text-base md:text-lg text-stone-600 leading-relaxed">
          Whether you&rsquo;re dealing with unreliable rides, difficult scheduling, high
          transportation costs, employee commuting challenges or managing multiple transport
          providers — tell us what you&rsquo;re dealing with.
        </p>
        <button
          onClick={scrollToForm}
          data-testid="problem-cta-button"
          className="mt-8 rounded-full bg-stone-900 px-7 py-3 text-sm font-semibold text-white hover:bg-stone-800 hover:-translate-y-px transition-[background-color,transform] duration-200"
        >
          Tell Us Your Requirements
        </button>
      </motion.div>
      <motion.ul
        data-testid="problem-list"
        className="space-y-4 lg:pt-14"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6, delay: 0.15 }}
      >
        {painPoints.map((p, i) => (
          <li
            key={p}
            className="flex items-center gap-4 bg-white rounded-xl border border-stone-200 px-6 py-4"
          >
            <span className="font-['Manrope'] text-sm font-bold text-orange-600 tabular-nums">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="text-sm md:text-base font-medium text-stone-700">{p}</span>
          </li>
        ))}
      </motion.ul>
    </div>
  </section>
);

export default Problem;
